import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  readTime: string;
  tags: string[];
}

const categoryNames: Record<string, string> = {
  'platform-recommend': '平台推荐',
  'bonus-guide': '领取攻略',
  'platform-review': '平台评测',
  'newbie-faq': '常见问题',
};

export default function ArticleCard({ slug, title, excerpt, category, image, date, readTime, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {categoryNames[category] || category}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{excerpt}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
              {readTime}
            </span>
          </div>
          <div className="flex items-center gap-1 text-primary-500 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
            <span>阅读更多</span>
            <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}